import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel } from "./carousel/carousel";
import styles from "./vehicles-in-stock.module.css";
import sharedStyles from "../../landing-feature-store-page.module.css";
import { StoreCtaButton } from "../cta-button";
import { capitaliseFirstLetter } from "../../utils/capitalise-first-letter";
export var VehiclesInStock = function(param) {
    var slug = param.slug, vehicles = param.vehicles;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.root,
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: sharedStyles.heading,
                children: "Cars in stock at cinch store ".concat(capitaliseFirstLetter(slug))
            }),
            /*#__PURE__*/ _jsx(Carousel, {
                carouselName: "vehicles-in-stock-carousel",
                vehicles: vehicles
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.buttonWrapper,
                children: /*#__PURE__*/ _jsx(StoreCtaButton, {
                    slug: slug,
                    trackEventTitle: "cars in stock at cinch store"
                })
            })
        ]
    });
};
